import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchProductGroups } from '../../../../actions/product/productGroupList'
import { AppState } from '../../../../reducers'
import { FiltersBar, FilterTextField } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { ProductGroupListState } from '../../../../reducers/product/productGroupList'
import { Button, Stack } from '@mui/material'
import ProductGroup from '../../../../models/ProductGroup'
import ProductGroups from '../ProductGroups'

interface Props {
  fullInfo?: boolean
  productGroupList: ProductGroupListState
}

const ProductGroupList: React.FC<Props> = ({ productGroupList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('product')
  const [edit,] = useState(false)

  useEffect(() => {
    dispatch(fetchProductGroups(history.location.search))
  }, [dispatch, history.location.search, edit])


  const linkToProductGroupEdit = (productGroup: ProductGroup) => {
    const editUrl = `/admin/productGroups/update/${productGroup.id}`
    history.push(editUrl, { update: edit })
  }

  return (
    <div>
      <FiltersBar>
        <FilterTextField style={{marginRight:"10px"}} name="code" label={t("code")} />
        <FilterTextField style={{maxWidth:"400px", width:"400px", marginRight:"10px"}} name="description" label={t("description")} />
      </FiltersBar>
      <ProductGroups
        rows={(productGroupList.productGroups || []).map(s => ({ data: s }))}
        loading={productGroupList.isFetching}
        pagination={productGroupList.pagination || undefined}
        onClickInfo={linkToProductGroupEdit}
      />

      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none' }}  onClick={() => history.push('/admin/productGroups/create', { title: t('create') })}>
        {`${t('create')}${t('group')}`}
        </Button>
      </Stack>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  productGroupList: state.productGroupList,
})

export default connect(mapStateToProps, null)(ProductGroupList)